define('drops/planningGraph/planninggraphimpl',[
    'jquery',
    'lq/dayTime'
], function ($, dayTime) {
    'use strict';

    function PlanningGraphImpl(container, piping) {
        this.container = container;
        this.graphData = {};
        this.system = {};
        this.parameters = piping.parameters;
        this.formatter = piping.formatting.createFormatter();
    };

    PlanningGraphImpl.prototype.planningGraphMouseUp = function () {
        $(document).off('mousemove');
        $(document).off('touchmove');
        $("body").css('cursor', 'default');
    };

    PlanningGraphImpl.prototype.planningGraphMouseDown = function (e) {
        this.system.cursorX = e.clientX;

        var self = this;
        var clickedDiv = $($(e.target || e.srcElement)[0]);
        if (!clickedDiv.hasClass("selected") && !clickedDiv.parent().hasClass("selected")) return;
        var type = clickedDiv.attr('barType');
        var resizeDirection = clickedDiv.attr('resizeDirection');
        this.system.draggingDiv = $(e.target || e.srcElement)[0];

        
        switch (type) {
            case 'dragHandle':
                this.system.currentLeft = parseFloat(this.system.draggingDiv.style.left);
                this.system.currentRight = parseFloat(this.system.draggingDiv.style.right);

                $(document).on('mousemove', function (e) {
                    self.divMove(e);
                });
                $(document).on('touchmove',function (e) {
                    if (e.originalEvent.touches) e = e.originalEvent.touches[0];
                    self.divMove(e);
                });

                break;
            case 'resizeHandle':
                $("body").css('cursor', $(this.system.draggingDiv).css('cursor'));

                this.system.currentLeft = parseFloat($(this.system.draggingDiv).parent()[0].style.left);
                this.system.currentRight = parseFloat($(this.system.draggingDiv).parent()[0].style.right);

                if (resizeDirection == 'left') {
                    $(document).on('mousemove', function (e) {
                        self.divResizeLeft(e);
                    });
                    $(document).on('touchmove',function (e) {
                        if (e.originalEvent.touches) e = e.originalEvent.touches[0];
                        self.divResizeLeft(e);
                    });
                    break;
                }
                if (resizeDirection == 'right') {
                    $(document).on('mousemove', function (e) {
                        self.divResizeRight(e);
                    });
                    $(document).on('touchmove',function (e) {
                        if (e.originalEvent.touches) e = e.originalEvent.touches[0];
                        self.divResizeRight(e);
                    });
                }
                break;
        }
    };

    PlanningGraphImpl.prototype.getLeftLimit = function (rowArId, planArId) {
        var minLeft = this.graphData.rangeMin; //this.graphData.barValues[rowArId].Start;
        var myStart = this.graphData.barValues[rowArId].Plannings[planArId].Start;

        for (var i = 0; i < this.graphData.barValues[rowArId].Plannings.length; i++) {
            if (i != planArId) {
                var end = this.graphData.barValues[rowArId].Plannings[i].End;

                if (end > minLeft && end <= (myStart + (this.graphData.interval * 0.5))) {
                    minLeft = end;
                }
            }
        }

        minLeft = (minLeft - this.graphData.rangeMin);
        return minLeft * this.system.itemWidth;
    };

    PlanningGraphImpl.prototype.getRightLimit = function (rowArId, planArId) {
        var minRight = this.graphData.rangeMax; //this.graphData.barValues[rowArId].End;
        var myEnd = this.graphData.barValues[rowArId].Plannings[planArId].End;

        for (var i = 0; i < this.graphData.barValues[rowArId].Plannings.length; i++) {
            if (i != planArId) {
                var start = this.graphData.barValues[rowArId].Plannings[i].Start;

                if (start < minRight && start >= (myEnd - (this.graphData.interval * 0.5))) {
                    minRight = start;
                }
            }
        }

        minRight = (this.graphData.rangeMax - minRight);
        return minRight * this.system.itemWidth;
    };

    PlanningGraphImpl.prototype.divResizeLeft = function (e) {
        var plannerAvailableWidth = $(this.container).find(".colPlanner").width();
        var rowArId = $(this.system.draggingDiv).parent().parent().parent().attr('arId');
        var planArId = $(this.system.draggingDiv).parent().attr('arId');

        var offSet = (e.clientX - this.system.cursorX) / plannerAvailableWidth * 100;
        offSet = Math.round(offSet / (this.system.itemWidth * this.graphData.interval)) * (this.system.itemWidth * this.graphData.interval);

        var minLeft = this.getLeftLimit(rowArId, planArId);
        var maxLeft = 100 - parseFloat($(this.system.draggingDiv).parent()[0].style.right) - (this.system.itemWidth * this.graphData.interval);

        if (minLeft < 0) minLeft = 0;
        if (maxLeft > 100) maxLeft = 100;

        var newLeft = this.system.currentLeft + offSet;

        if (newLeft < minLeft) newLeft = minLeft;
        if (newLeft > maxLeft) newLeft = maxLeft;

        $(this.system.draggingDiv).parent()[0].style.left = newLeft + '%';

        this.setNewTotal($(this.system.draggingDiv).parent());
    };

    PlanningGraphImpl.prototype.divResizeRight = function (e) {
        var plannerAvailableWidth = $(this.container).find(".colPlanner").width();
        var rowArId = $(this.system.draggingDiv).parent().parent().parent().attr('arId');
        var planArId = $(this.system.draggingDiv).parent().attr('arId');

        var offSet = (e.clientX - this.system.cursorX) / plannerAvailableWidth * 100;
        offSet = Math.round(offSet / (this.system.itemWidth * this.graphData.interval)) * (this.system.itemWidth * this.graphData.interval);

        var minRight = this.getRightLimit(rowArId, planArId);
        var maxRight = 100 - parseFloat($(this.system.draggingDiv).parent()[0].style.left) - (this.system.itemWidth * this.graphData.interval);

        if (minRight < 0) minRight = 0;
        if (maxRight > 100) maxRight = 100;

        var newRight = this.system.currentRight - offSet;

        if (newRight < minRight) newRight = minRight;
        if (newRight > maxRight) newRight = maxRight;

        $(this.system.draggingDiv).parent()[0].style.right = newRight + '%';

        this.setNewTotal($(this.system.draggingDiv).parent());
    };

    PlanningGraphImpl.prototype.divMove = function (e) {
        var plannerAvailableWidth = $(this.container).find(".colPlanner").width();
        var rowArId = $(this.system.draggingDiv).parent().parent().attr('arId');
        var planArId = $(this.system.draggingDiv).attr('arId');

        var offSet = (e.clientX - this.system.cursorX) / plannerAvailableWidth * 100;
        offSet = Math.round(offSet / (this.system.itemWidth * this.graphData.interval)) * (this.system.itemWidth * this.graphData.interval);

        var minRight = this.getRightLimit(rowArId, planArId);
        var minLeft = this.getLeftLimit(rowArId, planArId);

        if (minLeft < 0) minLeft = 0;
        if (minRight < 0) minRight = 0;

        var originalDD = $(this.system.draggingDiv);

        if ((this.round(this.system.currentLeft + offSet) < this.round(minLeft))
		 || (this.round(this.system.currentRight - offSet) < this.round(minRight)))
            return;

        this.system.draggingDiv = originalDD.find('[resizeDirection=right]')[0];
        this.divResizeRight(e);

        this.system.draggingDiv = originalDD.find('[resizeDirection=left]')[0];
        this.divResizeLeft(e);

        this.system.draggingDiv = originalDD[0];
    };

    PlanningGraphImpl.prototype.round = function (floatingPercent) {
        var plannerAvailableWidth = $(this.container).find(".colPlanner").width();
        var x = (this.system.itemWidth * this.graphData.interval);

        var pix = Math.round(floatingPercent / 100 * plannerAvailableWidth);
        var res = pix / plannerAvailableWidth * 100;
        res = Math.round(res / x) * x;

        return res;
    };

    PlanningGraphImpl.prototype.setNewTotal = function (barDiv) {
        var start = (((parseFloat(barDiv[0].style.left)) / this.system.itemWidth) + this.graphData.rangeMin).toFixed(this.graphData.decimalPrecision);
        var end = (((100 - parseFloat(barDiv[0].style.right)) / this.system.itemWidth) + this.graphData.rangeMin).toFixed(this.graphData.decimalPrecision);

        start = Math.round(start / this.graphData.interval) * this.graphData.interval;
        end = Math.round(end / this.graphData.interval) * this.graphData.interval;

        var rowArId = $(barDiv).parent().parent().attr('arId');
        var planArId = $(barDiv).attr('arId');

        this.graphData.barValues[rowArId].Plannings[planArId].Start = this.system.usingDateTime ? this.gridLinePosToDate(start) : start;
        this.graphData.barValues[rowArId].Plannings[planArId].End = this.system.usingDateTime ? this.gridLinePosToDate(end) : end;

        var total = this.graphData.barValues[rowArId].Total();

        var totalValue;
        if (this.graphData.showAsTime == 1) {
            totalValue = dayTime.fromTicks(total);
        } else {
            totalValue = total;
        }

        $(barDiv).parent().parent().find('.itemTotal').text(totalValue);
    };

    PlanningGraphImpl.prototype.deleteGraph = function () {
        $(this.container).children().remove();
    };

    PlanningGraphImpl.prototype.createGraph = function () {
        var graph = "<div class='header row'>"
             + "<div class='itemName descriptionHeader'>" + this.graphData.descriptionLabel + "</div><div class='itemPlanningBar colPlanner'></div>"
             + "<div class='itemTotal totalHeader'>" + this.graphData.totalLabel + "</div></div>"
             + "<div class='tablePlanningItems'>"
            + "<div class='tablePlanningGridLabels tablePlanningGrid' style='margin-left:-8px; margin-right:30px;'></div>"
            + "<div class='rowItems'><div class='rowitms' style='Position:relative;min-height:100%;'><div class='tablePlanningGridLines tablePlanningGrid'></div></div></div></div>";

        $(this.container).append(graph);

        for (var i = 0; i < this.graphData.barValues.length; i++) {
            this.addRow(this.graphData.barValues[i], i);
        }

        if (this.graphData.showGrid == true) {
            this.drawLines();
        }

        var self = this;
        $(document).on('mouseup', function () {
            self.planningGraphMouseUp();
        });
        $(document).on('touchend', function () {
            self.planningGraphMouseUp();
        });
    };

    PlanningGraphImpl.prototype.addRow = function (planningItem, arId) {
        
        var totalValue;
        if (this.graphData.showAsTime) {
            totalValue = dayTime.fromTicks(planningItem.Total().toFixed(this.graphData.decimalPrecision));
        } else {
            totalValue = planningItem.Total().toFixed(this.graphData.decimalPrecision);
        }
        var optionalColor = '';
        if (planningItem.SelectedTextColor != null) {
            optionalColor = optionalColor + " color:" + planningItem.SelectedTextColor + "; ";
        }

        var newRowContent = "<div class='row' arId='" + arId + "'><div class='scrollable'></div>"
            + "<div class='itemName' style='z-index:4; " + optionalColor +"' itemId='" + planningItem.Id + "' title='" + planningItem.SelectedToolTip + "'>" + planningItem.SelectedName + "</div>"
            + "<div class='itemPlanningBar' id='" + planningItem.Id + "'>";

        if (planningItem.Boundary1start != null && planningItem.Boundary1stop != null) {
            var boundary1PositionLeft = (planningItem.Boundary1start - this.graphData.rangeMin) * this.system.itemWidth;
            var boundary1PositionRight = 100 - ((planningItem.Boundary1stop - this.graphData.rangeMin) * this.system.itemWidth);
            newRowContent += "<div class='planningPeriodBoundary1Start' style='left:0;width:" + boundary1PositionLeft.toString() + "%;'></div>";
            newRowContent += "<div class='planningPeriodBoundary1Start' style='right:0;width:" + boundary1PositionRight.toString() + "%;'></div>";
        }

        if (planningItem.Boundary2start != null && planningItem.Boundary2stop != null) {
            var boundary2PositionLeft = (planningItem.Boundary2start - this.graphData.rangeMin) * this.system.itemWidth;
            var boundary2PositionRight = 100 - ((planningItem.Boundary2stop - this.graphData.rangeMin) * this.system.itemWidth);
            newRowContent += "<div class='planningPeriodBoundary2Start' style='left:0;width:" + boundary2PositionLeft.toString() + "%;'></div>";
            newRowContent += "<div class='planningPeriodBoundary2Start' style='right:0;width:" + boundary2PositionRight.toString() + "%;'></div>";
        }

        for (var i = 0; i < this.system.diffInDays ; i++) {
            var startDay = this.system.oneDayRange * i;
            var endDay = this.system.oneDayRange * (i + 1);
            var unavailableStartLeft = startDay * this.system.itemWidth;
            var unavailableStartRight = 100 - (startDay + (planningItem.Start - this.graphData.rangeMin)) * this.system.itemWidth;
            var unavailableEndLeft = (startDay + (planningItem.End - this.graphData.rangeMin)) * this.system.itemWidth;
            var unavailableEndRight = 100 - (endDay * this.system.itemWidth);

            newRowContent += "<div class='planningPeriodUnavailableStart' style='left:"+unavailableStartLeft.toString()+"%;right:"+unavailableStartRight.toString()+"%;'></div>";
            newRowContent += "<div class='planningPeriodUnavailableEnd' style='left:" + unavailableEndLeft.toString() + "%;right:" + unavailableEndRight.toString() + "%;'></div>";
        }

        for (var i = 0; i < planningItem.Plannings.length; i++) {
            if (planningItem.Plannings[i].Start != null) {

                var start = this.getGridLinePos(planningItem.Plannings[i].Start);
                var end = this.getGridLinePos(planningItem.Plannings[i].End);
                if (start === end) continue;

                var selectedPositionLeft = start * this.system.itemWidth;
                var selectedPositionRight = (this.system.range - end) * this.system.itemWidth;
                var id = planningItem.Plannings[i].Id;
                var additionalClass = '';

                if (planningItem.Plannings[i].isPreference) {
                    additionalClass = ' isPreferenceBar';
                }

                if (planningItem.Plannings[i].isSpecial) {
                    additionalClass = ' specialBar';
                }

                if (planningItem.Plannings[i].isFlagged) {
                    additionalClass = ' flaggedBar';
                }

                if (id == this.morph.selectedBarId) {
                    additionalClass += ' selected';
                }

                var optionalColor = '';
                if (planningItem.Plannings[i].dynamicBarColor != null) {
                    optionalColor = optionalColor + " background:" + planningItem.Plannings[i].dynamicBarColor + "; ";
                    //Perhaps: add auto-gradient if works in all browsers
                    //optionalColor = optionalColor + " background:-webkit-linear-gradient(top, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.2) 100%); ";
                    //optionalColor = optionalColor + " background-color: " + planningItem.Plannings[i].dynamicBarColor + "; ";
                }
                if (planningItem.Plannings[i].dynamicTextColor != null) {
                    optionalColor = optionalColor + " color:" + planningItem.Plannings[i].dynamicTextColor + "; ";
                }

                newRowContent += "<div unselectable='on' barType='dragHandle' class='planningPeriodActual" + additionalClass + "' "
                    + "arId='" + i + "' "
                    + "itemId='" + id + "' "
                    + "total='" + planningItem.Total() + "' "
                    + "style='left:" + selectedPositionLeft.toString() + "%; "
                    + optionalColor
                    + " right:" + selectedPositionRight.toString() + "%;' "
                    + "title='" + planningItem.Plannings[i].Tooltip + "' "
                    + "alt='" + planningItem.Plannings[i].Tooltip + "'>"
                    + "<div barType='resizeHandle' resizeDirection='left'  class='resizeHandleLeft' parentId='" + planningItem.Id + "'></div>"
                    + planningItem.Plannings[i].Text
                    + "<div barType='resizeHandle' resizeDirection='right' class='resizeHandleRight' parentId='" + planningItem.Id + "'></div>"
                    + "</div>";
            }
        }

        newRowContent += "</div><div class='itemTotal'>" + totalValue + "</div></div>";

        var newRow = $(newRowContent);
        $(this.container).find(".rowitms").append(newRow);
        
        if (this.graphData.readOnly !== true) {
            var self = this;
            newRow.on('mousedown', function (e) {
                self.planningGraphMouseDown(e);
            });
            newRow.on('touchstart', function (e) {
                if (e.originalEvent.touches) e = e.originalEvent.touches[0];
                self.planningGraphMouseDown(e);
            });
            
            newRow.find(".planningPeriodActual").on('click', function () {
                self.clickedSelection($(this).attr('itemId'));
            });
            newRow.find(".planningPeriodActual").on('touchend', function () {
                self.clickedSelection($(this).attr('itemId'));
            });
            
            newRow.find(".itemName").on('click', function () {
                self.clickedOnDescription($(this).attr('itemId'));
            });
            
        }
    };

    PlanningGraphImpl.prototype.getGridLinePos = function (dateOrGridLinePos) {
        var value = (this.system.usingDateTime) ? this.dateToGridLinePos(dateOrGridLinePos) : dateOrGridLinePos;
        var pos = value - this.graphData.rangeMin;
        if (pos < 0) return 0;
        if (pos > this.system.range) return this.system.range;
        return pos;
    }
   
    PlanningGraphImpl.prototype.dateToGridLinePos = function (date) {
        return (new Date(date) - this.system.fromDate) / 1000;
    }

    PlanningGraphImpl.prototype.gridLinePosToDate = function (gridLinePos) {
        var date = new Date(this.system.fromDate);
        date.setSeconds(date.getSeconds() + gridLinePos);
        return date;
    }

    PlanningGraphImpl.prototype.drawLines = function () {
        for (var i = 0; i <= ((this.system.range / this.graphData.intervalGrid)) ; i++) {
            var left = this.round((this.system.itemWidth * this.graphData.intervalGrid) * i);
            var right = this.round((this.system.itemWidth * this.graphData.intervalGrid) * (((this.system.range / this.graphData.intervalGrid) - i) - 1));

            var gridLine = "<div class='gridLine' style='left:" + left + "%; right:" + right + "%'>";
            if (i % this.graphData.intervalGridMajor == 0) {
                gridLine = gridLine.replace("'gridLine'", "'gridLine mainInterval'");
            }
            gridLine += "</div>";
            $(this.container).find(".tablePlanningGridLines").append(gridLine);


            var gridLineLabel = "";
            if (this.graphData.showAxisLabels || this.graphData.showAxisLabelsTop) {
                if (this.graphData.showAsTime == 1) {
                    if (i % this.graphData.intervalGridLabel == 0) {
                        var labelValue = this.graphData.rangeMin + ((i) * this.graphData.intervalGrid);
                        while (labelValue >= this.system.oneDayRange) {
                            labelValue = labelValue - this.system.oneDayRange;
                        }
                        gridLineLabel += "<span class='gridLabel gridLabelBottom'>" + dayTime.fromTicks(labelValue) + "</span>";
                    }

                } else {
                    gridLineLabel += "<span class='gridLabel gridLabelBottom'>" + (this.graphData.rangeMin + ((i) * this.graphData.intervalGrid)) + "</span>";
                }
            } else {
                if (this.graphData.showAsTime == 1) {
                    if ((this.graphData.rangeMin + ((i) * this.graphData.intervalGrid)) % 3600 == 0) {
                        gridLineLabel += "<span class='gridLabel gridLabelBottom'></span>";
                    }
                }
            }
            if (gridLineLabel !== "" && this.graphData.showAxisLabels) $(this.container).find(".tablePlanningGridLabels").append("<div class='gridLineLabelBox' style='left:" + left + "%; right:" + right + "%'>" + gridLineLabel + "</div>");
            if (gridLineLabel !== "" && this.graphData.showAxisLabelsTop) $(this.container).find(".tablePlanningGridLabels").append("<div class='gridLineLabelBox' style='left:" + left + "%; right:" + right + "%'>" + gridLineLabel.replace("gridLabelBottom","gridLabelTop") + "</div>");
        }

        $(this.container).find(".gridLine .gridLabel").each(function () {
            var v = $(this);
            v.css('left', ((v.width() / 2) * -1) + "px");
        });

        if (this.graphData.showAsTime == 1) {
            for (var i = 0; i < this.system.diffInDays ; i++) {
                var left = this.round((this.system.itemWidth * this.system.oneDayRange) * i);
                var right = this.round((this.system.itemWidth * this.system.oneDayRange) * (((this.system.range / this.system.oneDayRange) - i) - 1));
                var gridLine = "<div class='gridLine dailyInterval' style='left:" + left + "%; right:" + right + "%;'></div>";
                $(this.container).find(".tablePlanningGridLines").append(gridLine);
                var gridLineLabel = "<div class='gridLineLabelBox' style='left:" + left + "%; right:" + right + "%;'><span class='gridLabel gridLabelBottom Day'>" + this.getDateLabel(i) + "</span></div>";
                if (this.graphData.showAxisLabels) $(this.container).find(".tablePlanningGridLabels").append(gridLineLabel);
                if (this.graphData.showAxisLabelsTop) $(this.container).find(".tablePlanningGridLabels").append(gridLineLabel.replace("gridLabelBottom","gridLabelTop"));
            }
            var left = this.round((this.system.itemWidth * this.system.oneDayRange) * i);
            var gridLine = "<div class='gridLine dailyInterval' style='left:" + left + "%; width:1px;'></div>";
            $(this.container).find(".tablePlanningGridLines").append(gridLine);
        }

        for (var j = 0; j < this.graphData.gridLines.length; j++) {
            var i = this.graphData.gridLines[j].Value / this.graphData.intervalGrid;
            var left = this.round((this.system.itemWidth * this.graphData.intervalGrid) * i);
            var right = this.round((this.system.itemWidth * this.graphData.intervalGrid) * (((this.system.range / this.graphData.intervalGrid) - i) - 1));
            var gridLine = "<div class='gridLine customInterval' style='left:" + left + "%; right:" + right + "%;'></div>";
            $(this.container).find(".tablePlanningGridLines").append(gridLine);
            var gridLineLabel = "<div class='gridLineLabelBox' style='left:" + left + "%; right:" + right + "%;'><span class='gridLabel gridLabelBottom custom'>" + dayTime.fromTicks(this.graphData.gridLines[j].Value) + "</span></div>";
            if (this.graphData.showAxisLabels) $(this.container).find(".tablePlanningGridLabels").append(gridLineLabel);
            if (this.graphData.showAxisLabelsTop) $(this.container).find(".tablePlanningGridLabels").append(gridLineLabel.replace("gridLabelBottom", "gridLabelTop"));
        }
    };

    PlanningGraphImpl.prototype.getDateLabel = function (offset) {
        if (!this.system.usingDateTime) return "";
        if (isNaN(this.system.fromDate)) return "";
        var date = new Date(this.system.fromDate);
        date.setDate(this.system.fromDate.getDate() + offset);
        return this.formatter.formatDate(date);
    }

    PlanningGraphImpl.prototype.clickedSelection = function (id) {
        //should be implemented to catch event
    };
    
    PlanningGraphImpl.prototype.clickedOnDescription = function (id) {
        //should be implemented to catch event
    };

    PlanningGraphImpl.prototype.hasUnsavedChanges = function () {
        for (var i = 0; i < this.graphData.barValues.length ; i++) {
            for (var j = 0; j < this.graphData.barValues[i].Plannings.length; j++) {

                var startNew = this.graphData.barValues[i].Plannings[j].Start;
                var startOld = this.graphData.barValues[i].Plannings[j]._origStart;
                var endNew = this.graphData.barValues[i].Plannings[j].End;
                var endOld = this.graphData.barValues[i].Plannings[j]._origEnd;
                
                if(startNew !== null && startNew instanceof Date) startNew = startNew.toISOString();
                if(startOld !== null && startOld instanceof Date) startOld = startOld.toISOString();
                if(endNew !== null && endNew instanceof Date) endNew = endNew.toISOString();
                if(endOld !== null && endOld instanceof Date) endOld = endOld.toISOString();

                if (startNew !== startOld || endNew !== endOld) return true;
            }
        }
        return false;
    };

    PlanningGraphImpl.prototype.getOutputData = function () {
        var data = [];
        if (this.graphData == undefined || this.graphData.barValues == undefined) return data;

        for (var i = 0; i < this.graphData.barValues.length ; i++) {
            for (var j = 0; j < this.graphData.barValues[i].Plannings.length; j++) {
                if (this.graphData.barValues[i].Plannings[j].Start != this.graphData.barValues[i].Plannings[j]._origStart || this.graphData.barValues[i].Plannings[j].End != this.graphData.barValues[i].Plannings[j]._origEnd) {
                    var plan = {
                        Id: this.graphData.barValues[i].Plannings[j].Id,
                        Start: this.system.usingDateTime ? this.formatter.formatLicquidDate(this.graphData.barValues[i].Plannings[j].Start) : this.graphData.barValues[i].Plannings[j].Start,
                        End: this.system.usingDateTime ? this.formatter.formatLicquidDate(this.graphData.barValues[i].Plannings[j].End) : this.graphData.barValues[i].Plannings[j].End
                    };

                    this.graphData.barValues[i].Plannings[j]._origStart = this.graphData.barValues[i].Plannings[j].Start;
                    this.graphData.barValues[i].Plannings[j]._origEnd = this.graphData.barValues[i].Plannings[j].End;
                    
                    data.push(plan);
                }
            }
        }
        return data;
    };

    PlanningGraphImpl.prototype.draw = function (morph, selectedGraphData) {
        this.deleteGraph();

        this.system.range = 0;
        this.system.oneDayRange = 0;
        this.system.diffInDays = 1;
        this.system.itemWidth = 0;
        this.system.cursorX = null;
        this.system.draggingDiv = null;
        this.system.currentLeft = null;
        this.system.currentRight = null;

        this.graphData = selectedGraphData;
        this.morph = morph;
        this.system.usingDateTime = this.graphData.usingDateTime;

        this.system.oneDayRange = (this.graphData.rangeMax - this.graphData.rangeMin);
        this.system.fromDate = this.formatter.parseLicquidDate(this.parameters.getValue(this.graphData.fromDateParameter));
        this.system.toDate = this.formatter.parseLicquidDate(this.parameters.getValue(this.graphData.toDateParameter));
        if (isNaN(this.system.toDate)) this.system.toDate = this.formatter.parseLicquidDate(this.parameters.getValue(this.graphData.fromDateParameter));
        
        this.system.diffInDays = Math.round(((this.system.toDate - this.system.fromDate) / 86400000) + 1);
        if (isNaN(this.system.diffInDays)) this.system.diffInDays = 1;
        this.system.range = this.system.oneDayRange * this.system.diffInDays;
        
        this.system.itemWidth = 100 / this.system.range;

        this.createGraph(selectedGraphData);
    };

    return PlanningGraphImpl;

});
